import script from "./TermoNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./TermoNotification.vue?vue&type=script&setup=true&lang=js"

import "./TermoNotification.vue?vue&type=style&index=0&id=fc31490e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc31490e"]])

export default __exports__